import {
  Dialog,
  DialogContent,
  FormControl,
  DialogTitle,
  Select,
  MenuItem,
  ListSubheader,
  DialogActions,
} from '@mui/material';
import React, { useState } from 'react';
import CustomButton from '../../../../../../../../lib/designSystem/Button';
import { useDispatch } from 'react-redux';
import CenteredCircularProgress from '../../../../../../../../lib/designSystem/CircularProgress';
import { editExecutive } from '../../../../../../../../lib/api/factoring';
import { showAlert } from '../../../../../../../../lib/functions/utils';

const EditExecutive = (props: any) => {
  const {
    openEditExecutive,
    setOpenEditExecutive,
    executivesPortfolio,
    executivesAll,
    executive,
    setExecutive,
    setUp,
    selectedRequest,
  } = props;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const confirmEditExecutive = async () => {
    setLoading(true);
    try {
      await editExecutive(dispatch, {
        factoringRequestId: selectedRequest.id,
        executiveId: executive,
      });
      setUp(selectedRequest.id);
      setOpenEditExecutive(false);
      showAlert(dispatch, 'success', 'Ejecutivo editado correctamente');
    } catch (error) {
      console.log(error);
      showAlert(dispatch, 'error', 'Error al editar el ejecutivo');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={openEditExecutive}
      onClose={() => setOpenEditExecutive(false)}
    >
      <DialogTitle>Editar Ejecutivo</DialogTitle>
      <DialogContent>
        {loading ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              minHeight: '100px',
            }}
          >
            <CenteredCircularProgress type="dialog" />
          </div>
        ) : (
          <FormControl fullWidth>
            <Select
              value={executive}
              onChange={(e) => setExecutive(e.target.value)}
            >
              <ListSubheader>Cliente en cartera</ListSubheader>
              {executivesPortfolio.map((executive: any) => (
                <MenuItem key={executive.id} value={executive.id}>
                  {executive.name}
                </MenuItem>
              ))}
              <ListSubheader>Todos</ListSubheader>
              {executivesAll.map((executive: any) => (
                <MenuItem key={executive.id} value={executive.id}>
                  {executive.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </DialogContent>
      <DialogActions>
        <CustomButton
          disabled={loading}
          onClick={() => setOpenEditExecutive(false)}
          color="secondary"
        >
          Cancelar
        </CustomButton>
        <CustomButton disabled={loading} onClick={() => confirmEditExecutive()}>
          Guardar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default EditExecutive;
